module.exports = __webpack_public_path__ + "img/iphone-2.e883c53c.svg";